import { Router } from 'react-router-dom';
import BrowserHistory from 'routers/history';
import { StoreProvider } from 'store/Store';
import { initialState, reducer } from 'store';
import Routes from './Routes';

BrowserHistory.listen(() => {
  // console.log('Set page to', location.pathname);
  // eslint-disable-next-line no-undef
  // ineum('page', location.pathname);
  // Note that the above can result in many useless pages when you are making use of path parameters.
  // In these cases you will have to define the page via different means, e.g. by creating a custom
  // Route component which accepts a 'pageName' property.
});

function App() {
  return (
    <StoreProvider
      initialState={initialState}
      reducer={reducer}
      history={BrowserHistory}
    >
      <Router history={BrowserHistory}>
        <Routes />
      </Router>
    </StoreProvider>
  );
}

export default App;
